import { render, staticRenderFns } from "./OrderLimit.vue?vue&type=template&id=0617061a&scoped=true"
import script from "./OrderLimit.vue?vue&type=script&lang=js"
export * from "./OrderLimit.vue?vue&type=script&lang=js"
import style0 from "./OrderLimit.vue?vue&type=style&index=0&id=0617061a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0617061a",
  null
  
)

export default component.exports